import React, { useEffect, useState } from 'react';
import { ArrowDown } from 'lucide-react';

const FeatureHighlight = ({ 
    isHighlighted, 
    children,
    featureRef 
}) => {
    const [showIndicator, setShowIndicator] = useState(false);

    useEffect(() => {
        if (isHighlighted) {
            setShowIndicator(true);
            const timer = setTimeout(() => {
                setShowIndicator(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [isHighlighted]);

    return (
        <div className="relative">
            {/* Floating arrow indicator */}
            {showIndicator && (
                <div className="absolute -top-12 left-1/2 transform -translate-x-1/2 animate-bounce">
                    <div className="bg-blue-500 text-white px-3 py-1 rounded-full flex items-center gap-2 shadow-lg">
                        <ArrowDown className="w-4 h-4" />
                        <span className="text-sm font-medium">View Feature</span>
                    </div>
                </div>
            )}

            {/* Feature content with highlight effect */}
            <div
                data-feature-ref={featureRef}
                className={`transition-all duration-300 relative ${
                    isHighlighted 
                        ? 'bg-blue-50 shadow-lg ring-2 ring-blue-500 ring-opacity-50 rounded-lg' 
                        : ''
                }`}
            >
                {isHighlighted && (
                    <div className="absolute inset-0 bg-blue-500 opacity-5 rounded-lg pointer-events-none" />
                )}
                <div className={`relative ${isHighlighted ? 'p-4' : ''}`}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default FeatureHighlight;